// White-on-AppBar input styling — applied only when a field sits on the dark toolbar (desktop).
// Inside the overflow Popover (mobile) the fields use the default dark-on-light theme colors.
// NOTE: intentionally scheme-INDEPENDENT (dark mode: customer-portal-qdc5). The AppBar surface is
// always dark — brand navy (#274052) in light mode, MUI's dark paper background in dark mode — so
// these white-on-dark fields stay legible in both schemes; tokenizing to theme text colors would
// break them on the light scheme's navy AppBar.
export const darkInputSx = {
	"& .MuiOutlinedInput-root": {
		color: "white",
		"& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
		"&:hover fieldset": { borderColor: "white" },
		"&.Mui-focused fieldset": { borderColor: "white" },
	},
	"& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.7)", opacity: 1 },
	"& .MuiInputLabel-root": { color: "rgba(255,255,255,0.7)" },
	// A resting label sits on the input's line: it ends before the picker's arrow rather than under it.
	"& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": { maxWidth: "calc(100% - 52px)" },
	"& .MuiInputLabel-root.Mui-focused": { color: "white" },
	"& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.7)" },
} as const;
